import {QRCode as QRCommon, Flex} from 'exsportia-components'
import React, {FC} from 'react'

import {QRCodeSettingsProps, defaultSettings} from './settings'

export type QRCodeProps = {
  value: string
  cursor?: string
  downloadable?: boolean
  onClick?: (e: any) => void
  settings?: QRCodeSettingsProps
  text?: string
}

export const QRCode: FC<QRCodeProps> = ({value, downloadable = true, cursor, onClick, settings, text}) => {
  return (
    <Flex onClick={onClick}>
      <QRCommon
        value={value}
        styleType='default'
        downloadable={downloadable}
        settings={{
          ...defaultSettings,
          ...settings,
          cursor,
        }}
        text={text}
      />
    </Flex>
  )
}
